import React, { PureComponent, Fragment } from 'react';

import dataRaw from '~/assets/data/wage.csv';
import { parseData, getTimeSections, getUserItem } from './utils';
import Slider from '../Slider';
import SalaryItem from '../SalaryItem';
import ac from '../appconfig';
import Icon from '../../../../core/scripts/components/Icon';

class SalaryApp extends PureComponent {
  lastGroup = null
  data = parseData(dataRaw)
  state = {
    userSalary: ac.startSalary
  }

  renderUserItem() {
    return (
      <SalaryItem
        isUser
        profession="Dein Monatsgehalt"
        wage={this.state.userSalary}
        months={1}
      />
    );
  }

  renderGroupItem(groupName) {
    return (
      <div className="salary__group">
        {groupName} {ac.groupSalaries[groupName]}
      </div>
    );
  }

  renderItem(d, i) {
    const addGroupLabel = this.lastGroup !== d.group;
    const userItem = getUserItem(this.state.userSalary, d.wage, this.data, i);
    const timeSections = getTimeSections(this.state.userSalary, d.wage);

    if (addGroupLabel) {
      this.lastGroup = d.group;
    }

    return (
      <Fragment key={d.profession}>
        {addGroupLabel && this.renderGroupItem(d.group)}
        {(userItem.isVisible && userItem.isBefore) && this.renderUserItem()}
        <SalaryItem {...d} {...timeSections} />
        {(userItem.isVisible && !userItem.isBefore) && this.renderUserItem()}
      </Fragment>
    );
  }

  onChangeSlider(userSalary) {
    this.setState({ userSalary });
  }

  render() {
    return (
      <Fragment>
        <Slider
          value={this.state.userSalary}
          onChange={val => this.onChangeSlider(val)}
        />
        <div className="salary__swoopywrapper">
          <div className="salary__swoopy">
            {ac.swoopyText}
          </div>
          <Icon type="arrow-curved" />
        </div>
        <div className="salary__items">
          {this.data.map((d, i) => this.renderItem(d, i))}
        </div>
      </Fragment>
    );
  }
}

export default SalaryApp;